const c = {
  name: "Giftcard",
  dimensions: { width: 40, height: 26 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 26" style="enable-background:new 0 0 40 26;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M5,0C2.2,0,0,2.2,0,5v16c0,2.8,2.2,5,5,5h30c2.8,0,5-2.2,5-5V5c0-2.8-2.2-5-5-5H5z M2,5c0-1.7,1.3-3,3-3h8.1
			v4.3C12.2,4.9,10.7,4,9,4c-3.2,0-5.5,3-4.7,6.1l0.1,0.2c0.2,0.6,0.4,1.2,0.8,1.7H2V5z M13.1,15.3V24H5c-1.7,0-3-1.3-3-3v-7h9.6
			l-4.2,4.2l1.4,1.4L13.1,15.3z M15.1,24v-8.5l4.2,4.2l1.4-1.4L16.4,14H38v7c0,1.7-1.3,3-3,3H15.1z M15.1,6.1V2H35c1.7,0,3,1.3,3,3
			v7H23c0.4-0.5,0.6-1.1,0.8-1.7l0.1-0.2C24.6,7,22.3,4,19.1,4C17.5,4,16,4.8,15.1,6.1z M9,12c-1.3,0-2.5-0.9-2.8-2.2L6.2,9.6
			C5.7,7.8,7.1,6,9,6c1.3,0,2.5,0.9,2.8,2.2l0,0l1,3.8H9z M21.8,9.8c-0.3,1.3-1.5,2.2-2.8,2.2h-3.7l1-3.8l0,0
			C16.6,6.9,17.8,6,19.1,6c1.9,0,3.2,1.8,2.8,3.6L21.8,9.8z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as Giftcard
};
